<template>
  <div>
    <z-input
      id="contact-name"
      v-model="contactName"
      label="Nombre del contacto"
      description="Gerente, propietario o persona a cargo"
      trim
      required
      class="mb-3"
    />
    <z-input
      id="address-phone"
      v-model="phone"
      label="Teléfono *"
      label-for="contact-phone"
      class="mb-4"
      name="phone"
      type="tel"
    />
    <z-input
      id="email"
      v-model="email"
      trim
      required
      label="Correo electrónico"
      class="mb-4"
    />
    <z-input
      id="password"
      v-model="password"
      trim
      required
      label="Contraseña"
    />
    <div class="mt-4">
      <z-button
        variant="secondary"
        class="mr-3"
        size="lg"
        @click="$emit('cancel')"
      >
        Cancelar
      </z-button>
      <z-button
        type="submit"
        size="lg"
        :disabled="!isValidForm || creating"
        :loading="creating"
        @click="$emit('accept')"
      >
        {{ acceptButtonText }}
      </z-button>
    </div>
  </div>
</template>

<script>
import ClientTypes from "@zubut/common/src/constants/clients/type";
import * as mutation from "@/store/modules/branch/mutations-types";
import { validateEmail, validatePhone, validateName } from "@/utils/strings";

export default {
  name: "ClientCreateStepTwo",

  props: {
    creating: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      vueTel: ""
    };
  },

  computed: {
    clientType() {
      return this.$store.state.branch.create.type;
    },

    contactName: {
      get() {
        return this.$store.state.branch.create.contactName;
      },
      set(val) {
        this.$store.commit(`branch/${mutation.SET_CONTACT_NAME}`, val);
      }
    },

    phone: {
      get() {
        return this.$store.state.branch.create.phone;
      },
      set(val) {
        this.$store.commit(`branch/${mutation.SET_PHONE}`, val);
      }
    },

    email: {
      get() {
        return this.$store.state.branch.create.email;
      },
      set(val) {
        this.$store.commit(`branch/${mutation.SET_EMAIL}`, val);
      }
    },

    password: {
      get() {
        return this.$store.state.branch.create.password;
      },
      set(val) {
        this.$store.commit(`branch/${mutation.SET_PASSWORD}`, val);
      }
    },

    validContactName() {
      return this.contactName.length > 1 && validateName(this.contactName);
    },

    validPhone() {
      return this.phone.length > 1 && validatePhone(this.phone);
    },

    validEmail() {
      return this.email.length > 1 && validateEmail(this.email);
    },

    validPassword() {
      return this.password.length > 1;
    },

    isValidForm() {
      return this.validContactName && this.validEmail && this.validPassword;
    },

    acceptButtonText() {
      if (this.clientType === ClientTypes.NUM_BRANCH) {
        return "Siguiente";
      }
      return "Crear";
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/utilities/text-size.scss";
</style>
